var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-tooltip"},[_c('information',{staticClass:"info-tooltip__icon",on:{"click":_vm.showModal}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }